export default {
  getGuestInfo: '/api/web/v2/doctorhomepage/getguestinfo',
  editGuestInfo: '/api/web/v2/doctorhomepage/editguestinfo'
}
